@if (searchEnabled && (isXsOrSm$ | async)) {
  <div class="container">
    <div class="row">
      <div class="col-12">
        <ng-template *ngTemplateOutlet="searchForm"></ng-template>
      </div>
    </div>
  </div>
}

@if (!showSidebar && (initialized$ | async)) {
  <div>
    <ng-template *ngTemplateOutlet="searchContent"></ng-template>
  </div>
}

@if (showSidebar && (initialized$ | async)) {
  <ds-page-with-sidebar [id]="'search-page'" [sideBarWidth]="sideBarWidth"
    [sidebarContent]="sidebarContent">
    <ng-template *ngTemplateOutlet="searchContent"></ng-template>
  </ds-page-with-sidebar>
}

<ng-template #searchContent>
  <div class="row">
    @if ((isXsOrSm$ | async) !== true) {
      <div class="col-12">
        @if (searchEnabled) {
          <ng-template *ngTemplateOutlet="searchForm"></ng-template>
        }
        <ng-content select="[additionalSearchOptions]"></ng-content>
      </div>
    }
    <div id="search-content" class="col-12">
      <div class="d-block d-md-none search-controls clearfix">
        @if (inPlaceSearch && showViewModes) {
          <ds-view-mode-switch [viewModeList]="viewModeList"
          [inPlaceSearch]="inPlaceSearch"></ds-view-mode-switch>
        }
        <button (click)="openSidebar()" aria-controls="#search-body"
          class="btn btn-outline-primary float-end open-sidebar"><i
        class="fas fa-sliders"></i> {{"search.sidebar.open"
        | translate}}
      </button>
    </div>
    <ng-content select="[searchContentTop]"></ng-content>
    @if (inPlaceSearch) {
      <ds-search-results
        [searchResults]="resultsRD$ | async"
        [searchConfig]="searchOptions$ | async"
        [configuration]="(currentConfiguration$ | async)"
        [disableHeader]="!searchEnabled"
        [linkType]="linkType"
        [context]="(currentContext$ | async)"
        [selectable]="selectable"
        [selectionConfig]="selectionConfig"
        [showCsvExport]="showCsvExport"
        [showThumbnails]="showThumbnails"
        (contentChange)="onContentChange($event)"
        (deselectObject)="deselectObject.emit($event)"
      (selectObject)="selectObject.emit($event)"></ds-search-results>
    }
  </div>
</div>
</ng-template>

<ng-template #sidebarContent>
  @if ((isXsOrSm$ | async) !== true) {
    <ds-search-sidebar id="search-sidebar"
      [configurationList]="configurationList"
      [configuration]="(currentConfiguration$ | async)"
      [currentScope]="(currentScope$ | async)"
      [filters]="filtersRD$.asObservable()"
      [refreshFilters]="refreshFilters"
      [resultCount]="(resultsRD$ | async)?.payload?.totalElements"
      [searchOptions]="(searchOptions$ | async)"
      [sortOptionsList]="(sortOptionsList$ | async)"
      [currentSortOption]="(currentSortOptions$ | async)"
      [inPlaceSearch]="inPlaceSearch"
      [viewModeList]="viewModeList"
      [showViewModes]="showViewModes"
      (changeConfiguration)="changeContext($event.context)"
    (changeViewMode)="changeViewMode()"></ds-search-sidebar>
  }
  @if ((isXsOrSm$ | async)) {
    <ds-search-sidebar id="search-sidebar-sm"
      [configurationList]="configurationList"
      [configuration]="(currentConfiguration$ | async)"
      [currentScope]="(currentScope$ | async)"
      [filters]="filtersRD$.asObservable()"
      [refreshFilters]="refreshFilters"
      [resultCount]="(resultsRD$ | async)?.payload?.totalElements"
      [searchOptions]="(searchOptions$ | async)"
      [sortOptionsList]="(sortOptionsList$ | async)"
      [currentSortOption]="(currentSortOptions$ | async)"
      [inPlaceSearch]="inPlaceSearch"
      [viewModeList]="viewModeList"
      [showViewModes]="showViewModes"
      (toggleSidebar)="closeSidebar()"
      (changeConfiguration)="changeContext($event.context)"
      (changeViewMode)="changeViewMode()">
    </ds-search-sidebar>
  }
</ng-template>

<ng-template #searchForm>
  <ds-search-form id="search-form"
    [query]="(searchOptions$ | async)?.query"
    [scope]="(searchOptions$ | async)?.scope"
    [hideScopeInUrl]="hideScopeInUrl"
    [currentUrl]="searchLink"
    [showScopeSelector]="showScopeSelector"
    [inPlaceSearch]="inPlaceSearch"
    [searchPlaceholder]="searchFormPlaceholder | translate">
  </ds-search-form>
  <div class="row mb-3 mb-md-1">
    <div class="labels col-12">
    <!--  <ds-search-labels [inPlaceSearch]="inPlaceSearch">
      </ds-search-labels>-->
    </div>
  </div>
</ng-template>
